import React from "react";
import { Provider } from "react-redux";
import configureStore from "store/publicPagesStore";
import Signup from "./signup";
import "../../styles/tailwind.css";

const store = configureStore();

export default function SignupWrapper() {
  return (
    <Provider store={store}>
      <Signup />
    </Provider>
  );
}
